export const PROPOSAL = 'PROPOSAL';
export const QUOTE = 'QUOTE';
export const ORIGINAL = 'ORIGINAL';
export const BASIC = 'BASIC';
export const MODERN = 'MODERN';
export const CUSTOMIZABLE_QUOTE_TEMPLATE = 'CUSTOMIZABLE_QUOTE_TEMPLATE';
export const CPQ_QUOTE = 'CPQ_QUOTE';